import { Component, input, inject } from '@angular/core';
import { TableColumn } from '../../../../shared/components/kit/table/table.types';
import { PersonFoldersInOrganizationStore } from './person-folders-in-organization.store';
import { PersonGridItemObject } from '@it2go/types';
import { CardTableComponent } from '../../../../shared/components/kit/table/card-table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';

@Component({
    selector: 'app-person-folders-in-organization',
    templateUrl: './person-folders-in-organization.component.html',
    styleUrl: './person-folders-in-organization.component.scss',
    providers: [PersonFoldersInOrganizationStore],
    imports: [
        CardTableComponent,
        PrimeTemplate,
    ],
})
export class PersonFoldersInOrganizationComponent {
    protected readonly store = inject(PersonFoldersInOrganizationStore);

    person = input<PersonGridItemObject | null>(null);

    protected columns: TableColumn[] = [
        {
            name: 'service',
        },
        {
            name: 'typeOfService',
        },
        {
            name: 'workplace',
        },
    ];

}
